module.exports = __webpack_public_path__ + "img/Number=22.f2f0d6bf.png";